export type KeyMap<T> = {
  [K in keyof T]?: T[K];
};

export type PageCriteria = { pageIndex?: number, pageSize?: number }

export type PageableFilter<T> = KeyMap<T> & PageCriteria;
